import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles'
import PropTypes from 'prop-types'

// COMPONENTS
import StepConnector from '@material-ui/core/StepConnector'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import IconStep from './StepIcon'
import Button from '@material-ui/core/Button'

const styles = theme => ({
  steperWrap: {
    position: 'relative',
    width: 185,
    flexShrink: 0,
    marginTop: 37,
    marginRight: 24,
  },
  root: {
    padding: '0',
    backgroundColor: 'transparent',
  },
  button: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  actionsContainer: {
    display: 'none',
    marginBottom: theme.spacing.unit * 2,
  },
  connectorLine: {
    height: '100%',
    opacity: 0.2,
    borderColor: '#8866ff',
    borderRightStyle: 'none',
    borderLeftStyle: 'solid',
    borderLeftWidth: 1,
    '&:nth-last-child': {
      minHeight: 80,
    },
  },
  connectorVertical: {
    height: 40,
    padding: 0,
    marginLeft: 14,
    '&:nth-of-type(6)': {
      height: 74,
    },
  },
  connectorVerticalFinished: {
    height: 25,
    padding: 0,
    marginLeft: 14,
    '&:nth-of-type(6)': {
      height: 25,
    },
  },
  customLabel: {
    position: 'relative',
    alignItems: 'flex-start',
    fontSize: 12,
    fontWeight: 'normal',
    color: 'rgb(0, 0, 0, 0.4)',
    lineHeight: 1.2,
    whiteSpace: 'pre',
  },
  customlabelContainer: {
    position: 'absolute',
    width: 110,
    left: 40,
  },
  customLabelCompleted: {
    color: 'rgb(0, 0, 0, 0.4) !important',
  },
  leftSteperConector: {
    height: 1,
    width: 42,
    position: 'absolute',
    top: 14,
    left: -42,
    zIndex: 10,
    backgroundColor: '#8866ff',
  },
})

class AppStepper extends React.Component {
  render() {
    const {classes, activeStep, steps} = this.props

    const connector = (
      <StepConnector
        classes={{
          active: classes.connectorActive,
          completed: classes.connectorCompleted,
          disabled: classes.connectorDisabled,
          line: classes.connectorLine,
          vertical:
            activeStep < 3
              ? classes.connectorVertical
              : classes.connectorVerticalFinished,
        }}
      />
    )

    return (
      <div className={classes.steperWrap}>
        <div className={classes.leftSteperConector}/>
        <Stepper
          activeStep={activeStep}
          orientation="vertical"
          connector={connector}
          classes={{
            root: classes.root,
          }}
        >
          {steps.map(label => (
            <Step key={label}>
              <StepLabel
                classes={{
                  root: classes.customLabel,
                  label: classes.customLabel,
                  disabled: classes.customLabel,
                  labelContainer: classes.customlabelContainer,
                  completed: classes.customLabelCompleted,
                }}
                StepIconComponent={IconStep}
                StepIconProps={{
                  classes: {
                    root: classes.icon,
                    active: classes.icon_active,
                  },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div className={classes.actionsContainer}>
          <div>
            <Button
              onClick={this.handleBack}
              className={classes.button}
            >
              Back
            </Button>
            {activeStep !== steps.length ? (
              <Button
                disabled={activeStep === steps.length}
                variant="contained"
                color="primary"
                onClick={this.handleNext}
                className={classes.button}
              >
                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    )
  }
}

AppStepper.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(AppStepper)
